'use strict';

var intentionToAssetColor$1 = require('../../../../../../../../_virtual/intentionToAssetColor.cjs');
require('../types/base/ds5/assetColors.cjs');
var assetColors$1 = require('../../../../../../../../_virtual/assetColors.cjs');

var assetColors = assetColors$1.__exports;

/**
 * Convert the intention to the asset color
 */ const intentionToAssetColor = (intent)=>{
    switch(intent){
        case "success":
            return assetColors.ASSET_COLORS.green;
        case "info":
            return assetColors.ASSET_COLORS.blue;
        case "critical":
            return assetColors.ASSET_COLORS.red;
        case "warning":
            return assetColors.ASSET_COLORS.orange;
        case "recur":
            return assetColors.ASSET_COLORS.purple;
        case "discovery":
            return assetColors.ASSET_COLORS.sand;
        case "neutral":
        default:
            return assetColors.ASSET_COLORS.grey;
    }
};

intentionToAssetColor$1.__exports.intentionToAssetColor = intentionToAssetColor;

module.exports = intentionToAssetColor$1.__exports;
//# sourceMappingURL=intentionToAssetColor.cjs.map
